import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import vector from '../../assets/Vector.png';
import formatSumAssured from '../../utilities/calculateSum';
import { updateFirstPageData, healthEnquiryAPI } from '../../Redux/HealthRedux';

const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 60px !important;
  align-items: flex-start;
  justify-content: space-between;
  background-color: #f1f1f1;
  padding: 7px 30px;
  border-radius: 12px;
  gap: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

const LabelIcon = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  gap: 6px;
  font-size: 15px;
  font-weight: 600;
  color: #333;
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-size: 12px;
  font-weight: 500;
  color: #333;
  padding-left: 2px;
`;

const StyledSelect = styled.select`
  border: 1px solid #ccc;
  background-color: #fff;
  padding: 8px 12px;
  font-size: 14px;
  border-radius: 6px;
  min-width: 140px;
  transition: border-color 0.2s ease;

  &:focus {
    border-color: #f6931e;
    outline: none;
    box-shadow: 0 0 0 3px rgba(246, 147, 30, 0.15);
  }
`;

const StyledInput = styled.input`
  border: 1px solid #ccc;
  background-color: #fff;
  padding: 8px 12px;
  font-size: 14px;
  border-radius: 6px;
  width: 140px !important;
  height: 35px;
  transition: border-color 0.2s ease;

  &:focus {
    border-color: #f6931e;
    outline: none;
    box-shadow: 0 0 0 3px rgba(246, 147, 30, 0.15);
  }
`;

const SubmitButton = styled.button`
  background: linear-gradient(45deg, #41025f, rgb(108, 28, 146));
  color: #fff;
  border: 1px solid #f6931e;
  padding: 10px 24px;
  margin-top: 6px;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.15);
  }
`;


const InputRow = styled.div`
  display: flex;
  gap: 25px;
  align-items: center;
  flex-grow: 1;
  flex-wrap: wrap;
`;


export const FilterBar = ({ CallQuoteAPIs }) => {
  const combinedRedux = useSelector(
    (state) => state.health.septateCombinedRedux
  );
  const dispatch = useDispatch();

  const [healthFilter, setHealthFilter] = useState({
    tenure: combinedRedux.tenure || '',
    sumAssured: combinedRedux.sumAssured || '500000',
  });

  const tenureOptions = ['Select', '1', '2', '3', '4', '5'];

  const handleInputChange = (field) => (e) => {
    const value = e.target.value;
    setHealthFilter((prev) => ({
      ...prev,
      [field]: value === 'Select' ? '' : value,
    }));
  };

  const handleSumAssured = (value) => {
    setHealthFilter((prev) => ({
      ...prev,
      sumAssured: value || '500000',
    }));
  };

  const handleSubmit = () => {
    dispatch(
      updateFirstPageData({
        sumAssured: healthFilter.sumAssured,
        tenure: healthFilter.tenure,
        enquiryId: combinedRedux.enquiryId,
      })
    )
      .then(() => {
        dispatch(healthEnquiryAPI({ enquiryId: combinedRedux.enquiryId }));
        CallQuoteAPIs();
      })
      .catch(console.error);
  };

  return (
    <FilterContainer>
      <LabelIcon>
        Filters
        <img style={{ paddingLeft: '5px' }} src={vector} alt="icon" />
      </LabelIcon>

      <InputRow>
        <InputGroup>
          <Label>Tenure</Label>
          <StyledSelect
            value={healthFilter.tenure}
            onChange={handleInputChange('tenure')}
          >
            {tenureOptions.map((opt, idx) => (
              <option key={opt + idx} value={opt}>
                {opt} {" "}
                {opt !== 'Select' ? 'Years' : 'Tenure '}
              </option>
            ))}
          </StyledSelect>
        </InputGroup>

        <InputGroup>
          <Label>
            Sum Assured ({formatSumAssured(healthFilter.sumAssured)})
          </Label>
          <StyledInput
            type="text"
            placeholder="Enter Sum Assured"
            value={healthFilter.sumAssured}
            onChange={(e) => handleSumAssured(e.target.value)}
          />
        </InputGroup>
      </InputRow>

      <SubmitButton onClick={handleSubmit}>Apply Filters</SubmitButton>
    </FilterContainer>
  );
};
